import { motion } from 'framer-motion';
import '../assets/css/home.css';
import { homeIcons } from '../assets/images/home';
import Header from '../components/home/Header';
import Vector1 from '../components/homeVectors/Vector1';
import Vector2 from '../components/homeVectors/Vector2';
import ConnectSection from '../components/home/ConnectSection';
import IntroSection from '../components/home/IntroSection';
import Vector4 from '../components/homeVectors/Vector4';
import AppSection from '../components/home/AppSection';
import Vector5 from '../components/homeVectors/Vector5';
import PowerSection from '../components/home/PowerSection';
import Vector7 from '../components/homeVectors/Vector7';
import StudentSection from '../components/home/StudentSection';
import Vector8 from '../components/homeVectors/Vector8';
import Footer from '../components/home/Footer';


export default function Home() {
    return (
        <div id="homeContainer">
            <Header />
            <Vector1 />
            <Vector2 />
            <motion.div id="vector3" className="vector"
                initial={{ opacity: 0, y: 100 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.5, delay: 0.5}}
            >
                <img src={homeIcons.orange} alt="Décoration à droite"/>
            </motion.div>  
            <ConnectSection />
            <IntroSection />
            <Vector4 />
            <AppSection />
            <Vector5 />
            <motion.div id="vector6" className="vector"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 2 }}
                viewport={{ once: true, amount: 0.9 }}
            >
                <img src={homeIcons.orange} alt="Décoration"/>
            </motion.div>
            <PowerSection />
            <Vector7 />
            <StudentSection />
            <Vector8 />
            <motion.div id="vector9" className="vector"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.5 }}
                viewport={{ once: true, amount: 0.9 }}
            >
                <img src={homeIcons.orange} alt="Décoration à droite"/>
            </motion.div>
            <Footer />
        </div>   
    );
}